/**
 * Anchor — the concrete thing, shown at the top of a lab, in both registers.
 *
 * FOUNDER, 2026-08-15: "then do the anchors".
 *
 * ── IT OPENS THE LAB, BECAUSE THAT IS WHEN IT IS NEEDED ───────────────────────────────────────
 * Not a footnote and not a "further reading" box. A learner arrives at chapter 3 having read
 * correct, plain prose with nothing familiar in it; the anchor is the first thing on the page,
 * before the instrument, because it is what makes the instrument legible.
 *
 * ── BOTH REGISTERS ARE SHOWN, NOT CHOSEN BETWEEN ──────────────────────────────────────────────
 * The audience is "a mariner or layman" and the page cannot know which arrived. Guessing would get
 * it wrong half the time, and a reader who finds one of the two familiar loses nothing by seeing
 * the other.
 *
 * ── AND THE LIMIT IS ON SCREEN, NOT IN A COMMENT ──────────────────────────────────────────────
 * `breaks` is rendered every time, in the same block, never behind a toggle. An analogy whose limit
 * is optional reading is an analogy that will be believed past its limit.
 */
import { anchorFor, ANCHORS } from './anchors.mjs';

export default function Anchor({ chapter }) {
  const a = anchorFor(chapter);
  if (!a) return null;
  return (
    <div className="anc">
      <div className="g-label">Something to hold onto</div>
      <div className="anc-two">
        <div className="anc-side">
          <b className="anc-thing">At sea — {a.sea.thing}</b>
          <p className="g-body">{a.sea.says}</p>
        </div>
        <div className="anc-side">
          <b className="anc-thing">Ashore — {a.shore.thing}</b>
          <p className="g-body">{a.shore.says}</p>
        </div>
      </div>
      <p className="g-body anc-holds"><b>What it holds:</b> {a.holds}</p>
      <p className="g-body anc-breaks"><b>Where it breaks:</b> {a.breaks}</p>
    </div>
  );
}
export { ANCHORS };
